import request from '@/axios'

export function role_list (customer_id, params) {
  return request({
    url: `/role/list_role/50/${customer_id}`,
    method: 'GET',
    params
  })
}

export function user_list (payload, schoolId, page, params = null, limit = 5) {

  return request({
    url: `/operationalUser/list/${schoolId}?page=${page}&limit=${limit}`,
    params,
    method: 'POST',
    data:payload
  })
}

export function create_user (school_id, query) {
  return request({
    url: `/operationalUser/create/${school_id}`,
    method: 'POST',
    data: query
  })
}

export function edit_user (operations_user_id) {
  return request({
    url: `/operationalUser/show/${operations_user_id}`,
    method: 'GET'
  })
}


export function update_user (operations_user_id, query, platform_customer_id) {
  return request({
    url:`operationalUser/inlineEdit/${operations_user_id}/${platform_customer_id}`,
    method: 'POST',
    data: query
  })
}

export function delete_users (payload, customer_id) {
  return request({
    url: `/operationalUser/delete/${customer_id}`,
    method: 'POST',
    data: payload
  })
}
export function getFilterList (query, schoolId) {
  return request({
    // url:`filter/filterlist/${query}`,
    // method:'GET'
    url: `/operationalUser/list/${schoolId}`,
    params:query,
    method:'GET'
  })
}


export function userSettings (operations_user_id, platform_customer_id) {
  return request({
    // url:`filter/filterlist/${query}`,
    // method:'GET'
    url: `/operationalUser/show/${operations_user_id}/${platform_customer_id} `,
    method:'GET'
  })
}

export function bulkUpdateApi (payload) {
  return request({
    url: '/operationalUser/bulk_update',
    method:'PUT',
    data:payload
  })
}
export function bulkEmailApi (payload) {
  return request({
    url: '/operationalUser/bulk_email',
    method:'POST',
    data:payload
  })
}
export function fetch_users (schoolId) {
  return request({
    url: `/operationalUser/short/list/${schoolId}`,
    method: 'GET'
  })
}
export function schoolSettings (customer_id) {
  return request({
    url: `users/get_address_details/${customer_id}`,
    method: 'GET'
  })
}
export function updateSchoolAddress (payload, customer_id) {
  return request({
    url: `users/update_address_details/${customer_id}`,
    method:'PUT',
    data:payload
  })
}
export function sendInvitation (customer_id, user_id) {
  return request({
    url: `/operationalUser/invitation/${customer_id}/${user_id}`,
    method:'GET'
  })
}
export function SinglefileUploadApi (payload) {
  return request({
    url: 'operationalUser/file/create',
    method: 'POST',
    data:payload
  })
}
export function SinglefileDeleApi (payload) {
  return request({
    url: 'operationalUser/file/delete',
    method: 'DELETE',
    data:payload
  })
}

export function fetchUserBySearch (payload, query_page, query) {
  return request({
    url: `operationalUser/global_search?attribute=${query.attribute}&direction=${query.direction}&field_type=${query.field_type}&page=${query_page.current_page}`,
    method: 'POST',
    data:payload
  })
}

export function updatePaymentSetting (payload, customer_id) {
  return request({
    url: `operationalUser/payout/create/${customer_id}`,
    method: 'POST',
    data:payload
  })
}

export function fetchPayoutSetting (payload, customer_id) {
  return request({
    url: `operationalUser/payout/show/${customer_id}`,
    method: 'POST',
    data:payload
  })
}
